export function getSupportedRails(send) {
  return (...args) =>
    send(
      {
        path: '/v1/rails',
        pathParameters: {},
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
